export default __webpack_public_path__ + "static/media/DSC_7992-edited.f8a37623.png";